import { fetch } from '@/common/request';

export interface ModelConfigVo {
  id: number;
  configName: string;
  provider: string;
  modelName: string;
  apiKeyRef: string;
  baseUrl?: string;
  temperature?: number;
  maxTokens?: number;
  topP?: number;
  topK?: number;
  enableThinking?: number;
  thinkingBudget?: number;
  /**
   * DashScope API 端点类型
   * - AUTO: 自动检测（qwen3.5系列自动使用多模态API）
   * - TEXT: 强制使用文本生成API（适用于非标准模型名称）
   * - MULTIMODAL: 强制使用多模态API（支持图像输入）
   */
  endpointType?: string;
  extraParams?: string;
  status?: number;
  createdBy?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface ModelConfigCreateReq {
  configName: string;
  provider: string;
  modelName: string;
  apiKeyRef: string;
  baseUrl?: string;
  temperature?: number;
  maxTokens?: number;
  topP?: number;
  topK?: number;
  enableThinking?: number;
  thinkingBudget?: number;
  endpointType?: string;
  extraParams?: string;
}

export interface ModelConfigUpdateReq extends ModelConfigCreateReq {
  id: number;
}

export interface ModelConfigListReq {
  keyword?: string;
  status?: number;
}

export interface ModelConfigToggleReq {
  id: number;
  status: number;
}

export interface IdReq {
  id: number;
}

export function createModelConfig(params: ModelConfigCreateReq): Promise<number> {
  return fetch(
    '/api/config/model/create',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export function updateModelConfig(params: ModelConfigUpdateReq): Promise<void> {
  return fetch(
    '/api/config/model/update',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export function deleteModelConfig(id: number): Promise<void> {
  return fetch(
    '/api/config/model/delete',
    {
      method: 'POST',
      body: JSON.stringify({ id }),
    },
    true
  );
}

export function toggleModelConfig(params: ModelConfigToggleReq): Promise<void> {
  return fetch(
    '/api/config/model/toggle',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}

export function getModelConfigDetail(id: number): Promise<ModelConfigVo> {
  return fetch(
    '/api/config/model/detail',
    {
      method: 'POST',
      body: JSON.stringify({ id }),
    },
    true
  );
}

export function getModelConfigList(params?: ModelConfigListReq): Promise<ModelConfigVo[]> {
  return fetch(
    '/api/config/model/list',
    {
      method: 'POST',
      body: JSON.stringify(params || {}),
    },
    true
  );
}

export const PROVIDER_OPTIONS = [
  { label: 'DashScope', value: 'dashscope' },
  { label: 'OpenAI', value: 'openai' },
  { label: 'Ollama', value: 'ollama' },
];